import { createReducer } from "@reduxjs/toolkit";

const initialState = "";

/**
 * Keeps service plan state
 *
 * @param  {Array} state: the new state
 * @param  {Object} action: action to be performed
 * @return {Object} the new state
 */
const downloadPortalReport = createReducer(initialState, {
  GET_DOWNLOAD_PORTAL_REPORT: (state, { value }) => value.payload,
});

export default downloadPortalReport;
